export const UPDATE_SHARED_ATP_TIMEFRAME = 'UPDATE_SHARED_ATP_TIMEFRAME';

export const updateSharedTimeframe = (range, index) => ({
  type: UPDATE_SHARED_ATP_TIMEFRAME,
  range,
  index,
});
